module.exports = __webpack_public_path__ + "img/sustainability@2x.fca61ea.webp";